import Vue from 'vue/dist/vue.esm'
import ReimbursementRequestForm from 'components/storefront/reimbursement-request-form.vue'

export default function buildReimbursementRequestFormApp(element) {
  new Vue({
    el: element,
    components: {
      ReimbursementRequestForm
    }
  })
}
